// File: src/components/packages/packages.js
// Last modified: 2025-11-07
// Fixed: Removed inconsistent state access - now only uses props from parent

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PackageCard from './../package/PackageComponent';
import SkeletonCard from './../package/SkeletonCard';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import './packages.scss';
import { useNavigate } from 'react-router-dom';
import LoginComponent from "../Login";
import Modal from '@mui/material/Modal';
import PriceModalComponent from '../PriceModal';
import { selectUser } from '../../store/slices/userSlice';

// Theme-aware Item component for dark mode support
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    padding: 0,
    textAlign: 'center',
    color: theme.palette.text.primary,
}));

/**
 * PackagesList Component
 * Displays a grid of package cards with loading states
 *
 * Props:
 * - packages: Array of package objects to display
 * - loading: Boolean indicating if packages are being loaded (optional, for parent control)
 */
const PackagesList = ({ packages, loading = false }) => {
    const navigate = useNavigate();
    const user = useSelector(selectUser);

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showPriceModal, setShowPriceModal] = useState(false);

    // Show skeleton cards while loading
    if (loading) {
        return (
            <Container>
                <Grid container spacing={4} style={{marginBottom: '100px'}}>
                    {[...Array(8)].map((_, index) => (
                        <Grid item xs={6} md={3} key={`skeleton-${index}`}>
                            <Paper elevation={3}>
                                <SkeletonCard />
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        );
    }

    // Handle package click
    const handleClick = (zPackage) => {
        if (showLoginModal) {
            return;
        }

        if (zPackage.isPackageFree) {
            navigate('/package?id=' + zPackage.id);
        } else if (!user || !user.name || !user.email) {
            setShowLoginModal(true);
        } else {
            setShowPriceModal(true);
        }
    };

    return (
        <div>
            <Container className={'fade-in-content'}>
                <Grid container spacing={4} style={{marginBottom: '100px'}}>
                    {packages.map(packageDto => (
                        <Grid item xs={6} md={3} key={packageDto.id}>
                            <Item
                                elevation={3}
                                onClick={() => handleClick(packageDto)}
                                style={{ cursor: 'pointer' }}
                            >
                                <PackageCard
                                    zPackage={packageDto}
                                    user={user}
                                />
                            </Item>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            {/* Login Modal */}
            <Modal
                open={showLoginModal}
                onClose={() => setShowLoginModal(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <LoginComponent
                    text={'To\'plamni ko\'rish uchun sahifamizda hisob ochishingiz lozim.'}
                />
            </Modal>

            {/* Price Modal */}
            <Modal
                open={showPriceModal}
                onClose={() => setShowPriceModal(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                className={'price-modal'}
            >
                <PriceModalComponent
                    text={'To\'plamni ko\'rish uchun uni sotib olishingiz kerak. Biz bilan telegram orqali bog\'laning:'}
                />
            </Modal>
        </div>
    );
};

export default PackagesList;
